import * as React from "react";
import { Button, TextField, Switch } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Slide, Grid } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import MenuItem from "@mui/material/MenuItem";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import {
  icons,
  occurances,
  months,
  appConstants,
} from "../../helpers/constants";
import "./AddBudgetDialog.css";
// Package for date picker
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";
import MultipleSelectChip from "../../Components/MultipleSelectChip";
import axiosInstance from "../../interceptor/interceptor";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CircularProgress from "@mui/material/CircularProgress";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { changeDateFormat } from '../../helpers/common';
import { useSelector, useDispatch } from "react-redux";
import { budgetActions } from "../../actions/budget.action";


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function AddBudgetDialog(props) {
  const [open, setOpen] = React.useState(false);
  const [step1, setStep1] = React.useState(true);
  const [step2, setStep2] = React.useState(false);
  const [isPremium, setIsPremium] = React.useState(false);
  const [notSure, setNotSure] = React.useState(false);
  // const [lastPaymentDate, setPaymentDate] = React.useState(dayjs());
  const [isLoading, setIsLoading] = React.useState(false);

  const startDate = useSelector((state) => state.varsReducer.startDate);
  const endDate = useSelector((state) => state.varsReducer.endDate);
  const minDate = dayjs().startOf('month').add(1, 'day').set('year', 2000).format('YYYY-MM-DD HH:mm:ss');
  const maxDate = dayjs().startOf('month').add(1, 'day').set('year', 2100).format('YYYY-MM-DD HH:mm:ss');

  const dispatch = useDispatch();
  const [inputField, setInputField] = React.useState({
    user_id: localStorage.getItem("user_text_obj_data1"),
    budget_type: "",
    name: "",
    amount: "",
    occurance: "",
    months: "",
    date_of_month: "",
    year: "",
    note: "",
    budget_icon: "",
    first_premium_date: dayjs(),
    last_premium_date:dayjs(),
    doc_link:"",
  });

  const setIcon = (icon) => {
    setInputField({ ...inputField, budget_icon: icon });
  };

  const inputsHandler = (e) => {
    if(e.target.name == "name" && e.target.value.length > 20){
      setInputField({ ...inputField, [e.target.name]: e.target.value.substring(0,20) });
    }
    if(e.target.name == "amount"){
      if(isNaN(e.target.value)){
        setInputField({ ...inputField, [e.target.name]:  e.target.value.substring(0,e.target.value.length-1) }); //
      }
      else if(e.target.value.length>8){
        setInputField({ ...inputField, [e.target.name]: e.target.value.substring(0,8) });
      }
      else {
        setInputField({ ...inputField, [e.target.name]: e.target.value });
      }
    }
    else if(e.target.name == "note" && e.target.value.length > 65){
      setInputField({ ...inputField, [e.target.name]: e.target.value.substring(0,65) });
    }
    else {
      setInputField({ ...inputField, [e.target.name]: e.target.value });
    }
  };
  const inputsHandler2 = (newVal) => {
    setInputField({ ...inputField, first_premium_date: newVal });
  };

  const inputsHandler3 = (newVal) => {
    setInputField({ ...inputField, last_premium_date: newVal });
  };


  const clearInputs = () => {
    setInputField({
      user_id: localStorage.getItem("user_text_obj_data1"),
      budget_type: "",
      name: "",
      amount: "",
      occurance: "",
      months: "", //new Date().getMonth().toString()
      date_of_month: "",
      year: "",
      note: "",
      budget_icon: "",
      first_premium_date:"",
      last_premium_date:"",
      doc_link:"",
    });
    setNotSure(false);
  };

  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const inputHandler2 = (inputMonths) => {
    const monthsArr = [];
    months.forEach((item, i) => {
      let index = inputMonths.indexOf(item.name);
      if (index > -1) {
        monthsArr.push(months[i].id);
      }
    });
    setInputField({ ...inputField, months: monthsArr.join() });
  };

  if (props.budgetDialog) {
    setOpen(props.budgetDialog);
  }

  const showNext = () => {
    // Data Validation
    if (inputField.name === "") {
      toast.info("Enter the Name", { type: "error" });
      return false;
    }
    if (isNaN(inputField.amount) || parseInt(inputField.amount) < 0) {
      toast.info("Only positive number in Amount", { type: "error" });
      return false;
    }

    if (notSure == false && inputField.date_of_month === "" && inputField.budget_type ==="expense" && isPremium == false) {
      toast.info("Enter the Date of Payment", { type: "error" });
      return false;
    }

    if (notSure == false &&  parseInt(inputField.date_of_month) > 31 && inputField.budget_type == "expense" && isPremium == false) {
      toast.info("Enter Date of Payment between 1 - 31", { type: "error" });
      return false;
    }


    if (
      notSure == false &&
      inputField.budget_type == "expense" &&
      inputField.occurance == ""
    ) {
      toast.info("Please select occurance to proceed", { type: "error" });
      return false;
    }

    // Set value of year if occurance is one time
    if (inputField.occurance == 1) {
      if (inputField.months.split(",").length != 1) {
        toast.info("Select one month for One Time Expense", {
          type: "error",
        });
        return false;
      }

      if (parseInt(inputField.months) < new Date().getMonth()) {
        const nxtYr = new Date().getFullYear() + 1;
        setInputField({ ...inputField, year: nxtYr });
      } else {
        setInputField({ ...inputField, year: new Date().getFullYear() });
      }
    }

    setStep1(false);
    setStep2(true);
  };
  const showBack = () => {
    setStep1(true);
    setStep2(false);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    clearInputs();
    setOpen(false);
    setStep1(true);
    setStep2(false);
  };

  const handleSubmit = async () => {
    if (inputField.budget_icon === "") {
      toast.info("Please select icon to save", { type: "error" });
      return false;
    }

    try {
      if(isPremium){
        inputField.first_premium_date = changeDateFormat(inputField.first_premium_date);
        inputField.last_premium_date = changeDateFormat(inputField.last_premium_date);
        const date = new Date(inputField.first_premium_date);
        inputField.date_of_month = date.getDate();
      }
      else {
        inputField.last_premium_date = null;
        inputField.last_premium_date = null;
      }
      
      let obj = {};
      if (notSure == true) {
        obj = { ...inputField };
        obj.amount = 0;
        obj.occurance = null;
        obj.months = null;
        obj.date_of_month = null;
        obj.year = null;
        obj.note = "";
      } else {
        obj = { ...inputField };
      }
      
      setIsLoading(true);
      const res = await axiosInstance.post(
        `api?method=create_budget`,
        obj
      );
      setIsLoading(false);
      clearInputs();
      toast(res.data.message);
      // update the monthly transaction
      fetchMonthlyBudget(obj.budget_type);
      setOpen(false);
      showBack();
    } catch (e) {
      toast.info(`Error: ${e}`, { type: "error" });
    }
  };

  // fetch monthly budget
  const fetchMonthlyBudget = (budget_type)=>{
    dispatch(
      budgetActions.getMonthlyBudget({
        user_id: localStorage.getItem('user_text_obj_data1'),
        start_date: startDate,
        end_date: endDate,
        callFrom: "server",
        budget_type: budget_type,
      })
    );
  }

  const listicons = icons.map((icon, index) => (
    <Grid item key={index} className="selectIcon">
      <input
          type="radio"
          name="test"
          checked={icon === inputField.budget_icon}
          id={'icon'+ index}
          onChange={(event) => setIcon(icon)}
        />
      <label key={icon} htmlFor={'icon'+ index}>        
        <LazyLoadImage src={"./images/icons/" + icon}
        width={70} height={70}
        className="grid-item"
        alt="Budget icon"
        onClick={(event) => setIcon(icon)}
      />
        {/* <Box
          component="img"
          direction="column"
          // alignItems="center"
          // justifyContent="center"
          className="grid-item"
          sx={{
            height: "70%",
            width: "50%",
            padding: "9px",
            maxHeight: { xs: 233, md: 167 },
            maxWidth: { xs: 350, md: 250 },
          }}
          onClick={(event) => setIcon(icon)}
          alt="Budget icon"
          src={"./images/icons/" + icon}
        /> */}
      </label>
    </Grid>
  ));

  const listMonths = months.map((val, index) => (
    <Grid item key={index} xs={4}></Grid>
  ));

  return (
    <div>
      {/* <ToastContainer /> */}
      <Button variant="outlined" onClick={handleClickOpen}>
        Budget <AddCircleOutlineIcon />
      </Button>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted={false}
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        className="modalBudgetForm"
      >
        <CloseIcon
          onClick={handleClose}
          sx={{
            position: "absolute",
            cursor: "pointer",
            right: 10,
            top: 10,
            color: (theme) => theme.palette.grey[500],
          }}
        />
        <DialogTitle>
          Create Budget
          {inputField.budget_type ? (
            " (" + capitalize(inputField.budget_type) + ")"
          ) : (
            <></>
          )}
        </DialogTitle>
        <form className="budget-form">
          {step1 ? (
            <DialogContent>
              {inputField.budget_type == "" ? (
                <Box className="center">
                  <Button
                    variant="outlined"
                    onClick={() =>
                      setInputField({ ...inputField, budget_type: "expense" })
                    }
                  >
                    Expense
                  </Button>
                  &nbsp; &nbsp;
                  <Button
                    variant="outlined"
                    onClick={() =>
                      setInputField({ ...inputField, budget_type: "income" })
                    }
                  >
                    Income
                  </Button>
                </Box>
              ) : (
                <>
                  <TextField
                    value={inputField.name}
                    onChange={inputsHandler}
                    style={{ marginBottom: "10px", width: "100%" }}
                    type="text"
                    label="Name"
                    variant="outlined"
                    name="name"
                    maxLength={20}
                  />
                  {inputField.budget_type == "expense" ? (
                    <>
                      <br />
                      Not sure about other details ?
                      <Switch
                        onClick={() => setNotSure(!notSure)}
                        checked={notSure}
                      />
                    </>
                  ) : (
                  <></>
                  )}
                  {notSure == false && inputField.budget_type == "expense" ? (
                    <>
                     
                      <br />
                      <TextField
                        style={{ marginBottom: "20px", width: "100%" }}
                        name="amount"
                        type="number"
                        label="Amount"
                        variant="outlined"
                        placeholder="0.00"
                        value={inputField.amount}
                        onChange={inputsHandler}
                      />
                      {/* value={new Intl.NumberFormat('en-IN', { }).format(inputField.amount)} */}
                      <br />
                      <TextField
                        id="select occurance"
                        style={{ marginBottom: "20px", width: "100%" }}
                        select
                        label="Occurance"
                        name="occurance"
                        onChange={inputsHandler}
                        defaultValue={inputField.occurance}
                      >
                        {occurances.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                      {listMonths}
                      {!isPremium ? (
                        <>
                          <TextField
                            value={inputField.date_of_month}
                            onChange={inputsHandler}
                            style={{ marginBottom: "10px", width: "100%" }}
                            type="number"
                            InputProps={{ inputProps: { min: 1, max: 31 } }}
                            label="Date of Payment"
                            variant="outlined"
                            name="date_of_month"
                          />
                          <br />
                        </>
                      ) : (
                        <></>
                      )}
                      {inputField.occurance !== 2 ? (
                        <MultipleSelectChip 
                          sx={{width:"100%"}}
                          inputHandler2={inputHandler2}
                          selectedMonths={inputField.months}
                        />
                      ) : (
                        <></>
                      )}
                      <TextField
                        value={inputField.note}
                        onChange={inputsHandler}
                        // style={{ marginBottom: "20px", width: "100%" }}
                        type="text"
                        label="Note"
                        variant="outlined"
                        name="note"
                        maxLength={65}
                      />
                      <br />
                      <br />
                      <Switch
                        onClick={() => setIsPremium(!isPremium)}
                        defaultChecked={isPremium}
                      />
                      Is a Premium/ Loan EMI ?
                      <br />
                      {isPremium ? (
                        <>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <MobileDatePicker
                            label="First Payment Date"
                            value={inputField.first_premium_date}
                            minDate ={minDate}
                            maxDate = {maxDate}            
                            onChange={(newValue) => {
                              inputsHandler2(newValue);
                            }}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </LocalizationProvider>
                        <br/><br/>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <MobileDatePicker
                            label="Last Payment Date"
                            value={inputField.last_premium_date}
                            minDate ={minDate}
                            maxDate = {maxDate}
                            onChange={(newValue) => {
                              inputsHandler3(newValue);
                            }}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </LocalizationProvider>
                        <br /><br />
                        <TextField
                        value={inputField.doc_link}
                        onChange={inputsHandler}
                        // style={{ marginBottom: "20px", width: "100%" }}
                        type="text"
                        label="Document link"
                        variant="outlined"
                        name="doc_link"
                      />

                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </>
              )}
            </DialogContent>
          ) : (
            <React.Fragment>
              <Box style={{cursor: "pointer", display:"flex", alignItems:"center", padding:"0 20px", marginBottom:"10px" }}>
                <KeyboardBackspaceRoundedIcon
                  onClick={showBack}
                  style={{ cursor: "pointer" }}
                />
                Choose Icon
              </Box>
              <Box sx={{ flexGrow: 1 }}>
                <Grid container>{listicons}</Grid>
              </Box>
              {/* <div className="icon-container">{listicons}</div> */}
            </React.Fragment>
          )}
          {inputField.budget_type != "" ? (
            <DialogActions>
              {step1 ? (
                <Button onClick={showNext} variant="outlined">Next</Button>
              ) : (
                <Button onClick={handleSubmit} variant="outlined">Save</Button>
              )}
            </DialogActions>
          ) : (
            <></>
          )}
        </form>
      </Dialog>
      {isLoading == false ? (
        <></>
      ) : (
        <div id="overlay">
          <div className="loader">
            <CircularProgress />
          </div>
        </div>
      )}
    </div>
  );
}
